import RadioGroup from "@/components/radio-group"
import { useFormContext } from "@/lib/form/form-context"
import { RadioParamSchema } from "@/lib/form/schema"
import { FormParamStatus, WidgetBaseProps } from "@/lib/form/types"
import { useWatch } from "@/lib/form/form"
import { Label } from "@/components/ui/label"
import { cn } from "@/lib/utils"

export interface RadioGroupWidgetProps
  extends WidgetBaseProps<RadioParamSchema> {
  className?: string
}

export default function RadioGroupWidget(props: RadioGroupWidgetProps) {
  const { className, schema, path } = props
  const { form, readOnly: ctxReadOnly, sheetHasActiveBreakdown } = useFormContext()

  const value = useWatch({
    form: form,
    name: path,
    deep: 1,
  })

  function handleChange(value: string) {
    form.setValue(
      path,
      {
        id: schema.id,
        value: value,
        status: FormParamStatus.DRAFT,
        recordedAt: new Date().toISOString(),
      },
      {
        shouldDirty: true,
        shouldTouch: true,
        shouldValidate: true,
      }
    )
  }

  function getPreviewValue(): string {
    if (value?.status === FormParamStatus.NOT_APPLICABLE) {
      return "NA"
    }

    if (!value?.value && sheetHasActiveBreakdown) {
      return "NA"
    }

    return value?.value || "PENDING"
  }

  if (value?.status && value?.status !== FormParamStatus.DRAFT) {
    return (
      <div className={cn("flex flex-col gap-y-1 text-sm", className)}>
        <Label>{schema.name}</Label>

        <p className="font-medium">{getPreviewValue()}</p>
      </div>
    )
  }

  return (
    <RadioGroup
      className={cn("text-sm", className)}
      options={schema.options}
      value={value?.value}
      onChange={handleChange}
      disabled={
        value?.status === FormParamStatus.DISABLED ||
        !!ctxReadOnly ||
        !!sheetHasActiveBreakdown
      }
    />
  )
}
